export const formatUserName = (
  user: UserData.User | undefined
): string | undefined =>
  user ? user.attributes.name || `名称未設定ユーザー(${user.id})` : undefined
